export const LOYALTY_POINTS_QUERY_KEY = 'loyalty-points-data';
